import type { ResourceProps } from '@refinedev/core'

export type ResourceName = 'scout' | 'osa-scheduling' | 'analytics'

export interface ResourceConfig {
  name: ResourceName
  list: string
  edit?: string
  show?: string
  create?: string
  meta?: {
    label?: string
    icon?: string
    canDelete?: boolean
  }
}

export const RESOURCES_CONFIG: ResourceConfig[] = [
  {
    name: 'scout',
    list: '/scouts',
    edit: '/scouts/edit/:id',
    show: '/scouts/show/:id',
    create: '/scouts/create',
    meta: {
      label: 'Scout Management',
      icon: '🔍',
      canDelete: true,
    },
  },
  {
    name: 'osa-scheduling',
    list: '/osa-scheduling',
    meta: {
      label: 'OSA Scheduling',
      icon: '📅',
    },
  },
  {
    name: 'analytics',
    list: '/analytics',
    meta: {
      label: 'Reports',
      icon: '📊',
    },
  },
]

export const getResourcesForRefine = (): ResourceProps[] => {
  return RESOURCES_CONFIG.map(({ name, list, edit, show, create, meta }) => ({
    name,
    list,
    edit,
    show,
    create,
    meta,
  }))
}

export const getResourceConfig = (name: ResourceName): ResourceConfig | undefined => {
  return RESOURCES_CONFIG.find(resource => resource.name === name)
}
